import { render } from "./SeatPlan.vue?vue&type=template&id=fec14066&scoped=true"
import script from "./SeatPlan.vue?vue&type=script&lang=js"
export * from "./SeatPlan.vue?vue&type=script&lang=js"

import "./SeatPlan.vue?vue&type=style&index=0&id=fec14066&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fec14066"]])

export default __exports__